import get from 'lodash/get';

export function isAlreadySelected<T extends Record<string, any>, K extends keyof T>(idx: number, field: K, values?: ReadonlyArray<T>)  {
  if (!values) return () => false;
  return (id: number) => {
    if (get(values, [idx, field]) == id) return false;
    return values.some(t => get(t, field) == id);
  };
}
